import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'export',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    exportToCsv: builder.mutation({
      query: ({ type, filters }) => {
        return ({
          url: `/exports/${type}`,
          method: 'POST',
          params: {
            filters: filters,
          },
        })
      },
    }),

    checkExportStatus: builder.query({
      query: ({ id, type }) => {
        return ({
          url: `/exports/${type}/${id}/status`,
        })
      },
    }),

    interruptExport: builder.mutation({
      query: ({ id, type }) => {
        return ({
          url: `/exports/${type}/${id}/interrupt`,
          method: 'POST',
        })
      },
    }),

    deleteCsvFile: builder.mutation({
      query: (type) => {
        return ({
          url: `/exports/${type}/destroy`,
          method: 'DELETE',
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useExportToCsvMutation,
  useCheckExportStatusQuery,
  useInterruptExportMutation,
  useDeleteCsvFileMutation,
} = extendedApi
